import Hunt from 'huntjs';
import { Breakpoints } from '../utils/breakpoints';
export const SetupInViewDetection = () => {

  const bp = new Breakpoints();
  let offset = -1 * window.innerHeight / 100;
  offset *= bp.breakpointDown('sm') ? 5 : 20;


  const els = document.querySelectorAll('.-detect-in-viewport');
  new Hunt(els, {
    offset,
    enter: (el) => {
      el.classList.add('-in-viewport');
    },
  });
};